import { Box } from '@mui/material';
import {
  GraphNode,
  Mermaid,
  TiptapEditor,
} from 'components/common/SparkOutputBoard/BoardNodeTypes';
import React from 'react';
import type { BoardNodeType } from 'types/entityTypes/boardNodeTypes';

type NodeSpecificOutputProps = {
  nodeType: BoardNodeType | undefined;
  output: string;
  onError: (errorMessage: string) => void;
};

function NodeSpecificOutput({
  nodeType,
  output,
  onError,
}: NodeSpecificOutputProps) {
  const getBoardNodeContent = () => {
    if (!nodeType) {
      return <></>;
    }
    console.log('sparkTestResults', typeof output, output);
    console.log('nodeType', nodeType.attributes.key);

    switch (nodeType.attributes.key) {
      case 'text':
        return (
          <TiptapEditor
            initialContent={output}
            readOnly={true}
            onError={onError}
          />
        );
      case 'text-experimental':
        return (
          <TiptapEditor
            initialContent={output}
            readOnly={true}
            onError={onError}
          />
        );
      case 'mermaid':
        return (
          <Mermaid
            initialContent={JSON.stringify(output)}
            readOnly={true}
            onError={onError}
          />
        );
      case 'graph':
        return (
          <GraphNode
            initialContent={output}
            readOnly={true}
            onError={onError}
            minWidth='450px'
          />
        );
      default:
        <></>;
    }
  };
  return <Box width='100%'>{getBoardNodeContent()}</Box>;
}

export default NodeSpecificOutput;
